import * as React from "react";
const SvgFiRrWalker = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-walker_svg__a)">
      <path
        fill="#062147"
        d="M22 18.172V5c0-2.757-2.243-5-5-5h-5.198a5.01 5.01 0 0 0-4.698 3.291L.06 22.658A1 1 0 0 0 1 24a1 1 0 0 0 .939-.658L6.428 11H20v7.172A3 3 0 0 0 18 21c0 1.654 1.346 3 3 3s3-1.346 3-3a3 3 0 0 0-2-2.828M7.155 9l1.828-5.025A3.01 3.01 0 0 1 11.802 2H17c1.654 0 3 1.346 3 3v4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-walker_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWalker;
